import axios from "axios";
import { message as AntdAlert } from "antd";
import { put } from "redux-saga/effects";
import * as actions from "../actions";
import { baseURL } from "../../../../globalUtils/axiosConfig";
import { errorHandler } from "../../../../components/unauthorizeHandler";

export function* handleFetchMaterialTypes({ data }) {

  try {
    const response = yield axios.get(`${baseURL}/material_type`, {
    });
    if (response.status === 200) {
      const mappedData = response.data.map(item => ({
        ...item,
      }));
      yield put(actions.fetchMaterialTypesSuccess(mappedData));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchMaterialTypesError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleFetchBoltTypes({ data }) {
  try {
    const response = yield axios.get(`${baseURL}/material_type?bolt=true`, {
    });
    if (response.status === 200) {
      const mappedData = response.data.map(item => ({
        ...item,
      }));
      yield put(actions.fetchBoltTypesSuccess(mappedData));
    } else {
      errorHandler(response.data);
    }
  } catch (error) {
    yield put(actions.fetchBoltTypesError());
    AntdAlert.error("Something went wrong!");
    console.log(error);
  }
}

export function* handleUpdateMaterialTypes({ data }) {
  const { uomCategory, id, uom, materialType } = data;

  try {
    const response = yield axios.patch(
      `${baseURL}/material_type/${id}`,
      {
        uom,
        materialType,
        uomCategory,
      }
    );
    if (response.status === 200) {
      AntdAlert.success("Material Type Updated Successfully");
      yield put(actions.updateMaterialTypesSuccess(data));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateMaterialTypesError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateMaterialTypesError(response.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleDeleteMaterialTypes({ data }) {
  const { id } = data;
  try {
    const response = yield axios.delete(
      `${baseURL}/material_type/${id}`
    );

    if (response.status === 200) {
      AntdAlert.success("Material Type Deleted Successfully");
      yield put(actions.deleteMaterialTypesSuccess(id));
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.deleteMaterialTypesError(response.data));
      errorHandler(response.data);
    }
  } catch ({ response }) {
    yield put(actions.deleteMaterialTypesError(response.data.data));
    AntdAlert.error("Something went wrong!");
    console.log(response);
  }
}

export function* handleCreateMaterialTypes({ data }) {
  try {
    const newData = JSON.parse(JSON.stringify(data));
    delete newData.id;
    console.log("handleCreateMaterialTypes-newData",newData);
    const response = yield axios.post(`${baseURL}/material_type`, {
      ...newData,
    });
    if (response.status === 201) {
      AntdAlert.success("Material Type Created Successfully");
      yield put(actions.createMaterialTypesSuccess(response.data));
      console.log(response.data);
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.createMaterialTypesError(data.id));
      errorHandler(response.data);
    }
  } catch (error) {
    console.log(error);
  }
}

export function* handleUpdateMaterialTypesOrder({ data }) {
  const materialTypesObj = {};

  data.forEach((el, i) => {
    materialTypesObj[el.id] = i;
  });

  const payload = {
    materialType: materialTypesObj
  };
  
  try {
    const response = yield axios.post(
      `${baseURL}/material_type/sort`,
      payload
    );

    if (response.status === 201) {
      AntdAlert.success("Material Type Order Updated Successfully");
      yield put(actions.updateMaterialTypesOrderSuccess(data));
      console.log("if.response.data", response.data);
    } else {
      AntdAlert.error("Something went wrong!");
      yield put(actions.updateMaterialTypesOrderError());
      errorHandler(response.data);
      console.log("else.response.data", response.data);
    }
  } catch ({ response }) {
    yield put(actions.updateMaterialTypesOrderError());
    AntdAlert.error("Something went wrong!");
    console.log("catch.response.data", response.data);
    console.log(response);
  }
}
